import u from "./ghl-ui.es1365.js";
function _(i, r) {
  return s(i, void 0, r);
}
function s(i, r, n) {
  var I = n.type(r), e = I && I.possibleLengths() || n.possibleLengths();
  if (!e)
    return "IS_POSSIBLE";
  if (r === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return s(i, "MOBILE", n);
    var t = n.type("MOBILE");
    t && (e = u(e, t.possibleLengths()));
  } else if (r && !I)
    return "INVALID_LENGTH";
  var L = i.length, f = e[0];
  return f === L ? "IS_POSSIBLE" : f > L ? "TOO_SHORT" : e[e.length - 1] < L ? "TOO_LONG" : e.indexOf(L, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
export {
  s as checkNumberLengthForType,
  _ as default
};
